import React from "react"
import { Select } from "antd"
import { DASHBOARD_PERIOD_VALUES } from "../../../contexts/ReportFiltersContext.context"
import SelectButton from "../../../components/atoms/SelectButton.atom"
import { DateTime } from "luxon"
import {
  getMondayOfCurrentWeek,
  getSundayOfCurrentWeek,
} from "../../../utils/date.utils"
import useReportFiltersContext from "../../../hooks/contextConsumers/useReportFiltersContext.hook"

const DashboardControls = () => {
  const {
    dashboardPeriod: period,
    setDashboardPeriod: setPeriod,
    dashboardDateRange: date,
    setDashboardRange: setDate,
  } = useReportFiltersContext()

  const today = DateTime.now()

  const selectOptions = (() => {
    if (period === DASHBOARD_PERIOD_VALUES.WEEKLY) {
      const currentWeek = today.startOf("week")
      const endOfWeek = currentWeek.endOf("week")
      const lastWeek = currentWeek.minus({ weeks: 1 })
      return [
        `Anterior (${lastWeek.weekNumber}/${String(lastWeek.year).slice(2)})`,
        `Actual (${endOfWeek.weekNumber}/${String(endOfWeek.year).slice(2)})`,
      ]
    } else {
      const lastMonth = today.minus({ months: 1 })
      return [
        `Anterior (${lastMonth.month}/${String(lastMonth.year).slice(2)})`,
        `Actual (${today.month}/${String(today.year).slice(2)})`,
      ]
    }
  })()

  const selectedPeriod = (() => {
    if (period === DASHBOARD_PERIOD_VALUES.WEEKLY) {
      if (today.weekNumber === date[0].weekNumber) {
        return selectOptions[1]
      } else {
        return selectOptions[0]
      }
    } else {
      if (today.month === date[0].month) {
        return selectOptions[1]
      } else {
        return selectOptions[0]
      }
    }
  })()

  return (
    <div className="dashboard-filter flex flex-1 align-items-center gap-3 mb-3 flex-column sm:flex-row">
      <Select
        style={{
          maxWidth: "155px",
          minWidth: "135px",
          width: "100%",
        }}
        value={period}
        onChange={(value) => {
          setPeriod(value)
          if (value === DASHBOARD_PERIOD_VALUES.WEEKLY) {
            setDate([getMondayOfCurrentWeek(), getSundayOfCurrentWeek()])
          } else {
            const startMonth = DateTime.local().startOf("month")
            setDate([startMonth, startMonth.endOf("month")])
          }
        }}
      >
        <Select.Option value={DASHBOARD_PERIOD_VALUES.WEEKLY}>
          Semanal
        </Select.Option>
        <Select.Option value={DASHBOARD_PERIOD_VALUES.MONTHLY}>
          Mensual
        </Select.Option>
      </Select>
      <div>
        <SelectButton
          value={selectedPeriod}
          options={selectOptions}
          className="dashboard-select-buttons-container"
          itemTemplate={(el) => {
            const isPrev = el.includes("Anterior")
            return (
              <div className="flex align-items-center justify-content-center gap-2">
                <i className={`pi ${isPrev ? "pi-history" : "pi-calendar"}`} />
                {el}
              </div>
            )
          }}
          onChange={(e) => {
            if (!e.value) return
            if (period === DASHBOARD_PERIOD_VALUES.WEEKLY) {
              const startWeek = DateTime.now().startOf("week")
              if (e.value === selectOptions[0]) {
                if (selectedPeriod === selectOptions[0]) {
                  return
                }
                setDate([
                  startWeek.minus({ weeks: 1 }),
                  startWeek.minus({ weeks: 1 }).endOf("week"),
                ])
              } else {
                setDate([startWeek, startWeek.endOf("week")])
              }
            } else {
              const startMonth = DateTime.now().startOf("month")
              if (e.value === selectOptions[0]) {
                if (selectedPeriod === selectOptions[0]) {
                  return
                }
                setDate([
                  startMonth.minus({ months: 1 }),
                  startMonth.minus({ months: 1 }).endOf("month"),
                ])
              } else {
                setDate([startMonth, startMonth.endOf("month")])
              }
            }
          }}
        />
      </div>
    </div>
  )
}

export default DashboardControls
